import React, { useEffect, useState, useContext } from "react";
import cx from "classnames";
import { Routes, Route, Navigate, createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @mui/material components
import { makeStyles } from "@mui/styles";
// core components
import Sidebar from "../components/Sidebar/Sidebar.js";
import routes from "routes.js";
import routesNoMenu from "routesnomenu.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import MenuEntites from "components/MenuEntites/MenuEntites";
import { DateProvider } from "../context/DateContext";
import { AdvancedSearchProvider } from "../context/AdvancedSearchContext";
import { EntiteProvider } from "../context/EntiteContext";
import { getAllowedRoutes } from "../helpers/GetAllowedRoutes";
import UserService from "../services/UserService";
import IdleTimer from "../services/IdleTimer";
import { NotificationContainer } from "react-notifications";
import "assets/css/customNotifications.css";
import IconButton from "@mui/material/IconButton";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import Paper from "@mui/material/Paper";
import MenuEntites2 from "components/MenuEntites/MenuEntites2.js";
import Home from "views/Home/Home.js";
import { useTheme } from "@mui/material";
let ps;


// require("dotenv").config();

export default function AdminLayout(props) {
  const routesfull = getAllowedRoutes(routesNoMenu.concat(routes));
  //const routesfull = routes.concat(routesNoMenu);
  const { ...rest } = props;

  //filter bar states
  //const [checkedLabel, setCheckedLabel] = React.useState("Mode simple");
  //const [checkedA, setCheckedA] = React.useState(false);
  const [selectDate, setSelectDate] = useState("1");
  const [datepickerDateBegin, setdpDateBegin] = useState("");
  const [datepickerDateEnd, setdpDateEnd] = useState("");
  //const [advancedSearch, setAdvancedSearch] = React.useState(null);

  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(true);
  const [menuEntitesActive, setMenuEntitesActive] = React.useState(false);
  //const [image, setImage] = React.useState(require("assets/img/sidebar-2.jpg"));
  const [color] = useState("blue");
  const [bgColor] = useState("black");
  // const [hasImage, setHasImage] = React.useState(true);
  //const [fixedClasses, setFixedClasses] = React.useState("dropdown");
  const [logo_silver] = useState(require("assets/img/AVOB_Silver.png"));
  const [logo_gold] = useState(require("assets/img/AVOB_Gold.png"));
  const [logo_platinum] = useState(require("assets/img/AVOB_Platinum.png"));

  //const [logoText, setLogoText] = React.useState(MenuOpenIcon);

  // styles
  const theme = useTheme();
  const useStyles = makeStyles(styles(theme));
  const classes = useStyles();


  const mainDivMenuEntitesInactive = cx({
    [classes.mainDivMenuEntitesInactive]: !menuEntitesActive,
  });
  const mainDivMenuEntitesActive = cx({
    [classes.mainDivMenuEntitesActive]: menuEntitesActive,
  });
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });
  const mainPanelClassesMenuEntitesActive =
    classes.mainPanelMenuEntitesActive +
    " " +
    cx({
      [classes.mainPanelSidebarMiniMenuEntitesActive]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });
  // ref for main panel div
  const mainPanel = React.createRef();

  //Idle Timer
  const [isTimeout, setIsTimeout] = useState(false);
  const timeout = process.env.REACT_APP_IDLETIMER;

  useEffect(() => {
    const timer = new IdleTimer({
      timeout: timeout,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        setIsTimeout(true);
      },
    });

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
      timer.cleanUp();
    };
  }, []);

  useEffect(() => {
    if (ps) ps.destroy();
    if (
      navigator.platform.indexOf("Win") > -1 &&
      window.location.pathname == "/admin/maps"
    ) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: true,
      });
    } else if (
      navigator.platform.indexOf("Win") > -1 &&
      window.location.pathname !== "/admin/maps"
    ) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }, [window.location.pathname]);

  const handleGroupChange = () => {
    mainPanel.current.scrollTop = 0;
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  const selectDateChange = (event) => {
    setSelectDate(event.target.value);
    if (event.target.value === "1") {
      setdpDateBegin(1569403157000);
      setdpDateEnd(1601026320000);
    }
    //setSelectDate(event.target.value);
  };
  const datepickerDateBeginChange = (event) => {
    //setSelectDate(event.target.value);
  };
  const datepickerDateEndChange = (event) => {
    //setSelectDate(event.target.value);
  };

  const buttonMenuEntites = () => {
    setMenuEntitesActive(!menuEntitesActive);
  };
  const getAllowRoutes = getAllowedRoutes(routes);
  const memv2versionactive = localStorage.getItem("memv2version") || 0;

  return (
    <div>
      {isTimeout ? (
        UserService.getLogout()
      ) : (
        <AdvancedSearchProvider>
          <EntiteProvider>
            <DateProvider>
              <div className={classes.wrapper}>
                <Sidebar
                  routes={getAllowRoutes}
                  logo={
                    memv2versionactive == 0
                      ? logo_silver
                      : memv2versionactive == 1
                        ? logo_gold
                        : logo_platinum
                  }
                  handleDrawerToggle={handleDrawerToggle}
                  open={mobileOpen}
                  color="green"
                  bgColor={bgColor}
                  miniActive={miniActive}
                  buttonMenuEntites={buttonMenuEntites}
                  pathname={window.location.pathname}
                  {...rest}
                />
                <div
                  className={
                    menuEntitesActive
                      ? mainDivMenuEntitesActive
                      : mainDivMenuEntitesInactive
                  }
                  ref={mainPanel}
                >
                  <MenuEntites2
                    routes={getAllowRoutes}
                    handleDrawerToggle={handleDrawerToggle}
                    handleSelectDateChange={selectDateChange}
                    handleDpDateBeginChange={datepickerDateBeginChange}
                    handleDpDateEndChange={datepickerDateEndChange}
                    handleGroupChange={handleGroupChange}
                    buttonMenuEntites={buttonMenuEntites}
                    selectDate={selectDate}
                    datepickerDateBegin={datepickerDateBegin}
                    datepickerDateEnd={datepickerDateEnd}
                    open={mobileOpen}
                    color={color}
                    bgColor={bgColor}
                    miniActive={miniActive}
                    {...rest}
                  />
                </div>

                <div
                  className={
                    menuEntitesActive
                      ? mainPanelClassesMenuEntitesActive
                      : mainPanelClasses
                  }
                  ref={mainPanel}
                >
                  {/* <Hidden smDown implementation="css"> */}
                  {/* <Paper sx={{ display: {  sm: 'block'} }} > */}
                  <div style={{ height: "46px", width: "13px", backgroundColor: "rgb(145 194 65)", position: "fixed", borderRadius: "0 0 3px 0px" }}>
                    {menuEntitesActive ? (
                      <IconButton
                        aria-label="MenuOpen"
                        onClick={buttonMenuEntites}
                        style={{ paddingLeft: "6px", paddingTop: "8px", marginLeft: "0px", color: "white", width: "10px" }}
                      >
                        <ArrowLeftIcon style={{ fontSize: '1.7rem' }} />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="MenuOpen"
                        onClick={buttonMenuEntites}
                        style={{ paddingLeft: "6px", paddingTop: "8px", marginLeft: "0px", color: "white", width: "10px" }}
                      >
                        <ArrowRightIcon style={{ fontSize: '1.7rem' }} />

                      </IconButton>
                    )}

                  </div>
                  {/* </Paper> */}
                  {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}

                  <div className={classes.content}>
                    <div className={classes.container}>
                      <Outlet />
                      {/* <Home />
                       <Routes>
                        {getRoutes(routesfull)}
                         <Navigate from="/admin" to="/admin/home" /> 
                      </Routes> */}
                    </div>
                  </div>

                </div>
              </div>
            </DateProvider>
          </EntiteProvider>
        </AdvancedSearchProvider>
      )}
      <NotificationContainer />
    </div>
  );
}
